<div *ngIf="showSpinner" style="width: 250px; height: 200px; position: absolute; top:0; bottom: 0; left: 0; right: 0; margin: auto; text-align: center;">
    <div>
        <p>Please wait while we redirect you</p>
    </div>
    <div style="width: 100px; height: 100px; position: absolute; top:0; bottom: 0; left: 0; right: 0; margin: auto;">
        <mat-spinner></mat-spinner>
    </div>
</div>